"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = "\n<head>\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n  {{> head_content}}\n  {{> styles}}\n</head>\n";